/**
 * The HEAD OFFICE store (owner, 23 Oct 2026: "some of items are recieved at
 * head office create a head office store it will be under arun ji he will in
 * and out materials coming in head office store for now he will add batteries
 * in the stock by scanning add serial number. later on head office vehicle
 * batteries can be changed from this stock as well").
 *
 * His answers the same day: a lot is scanned in with its size and company
 * picked once; a battery leaves fitted on a head office vehicle (the one it
 * replaces comes back in), sent to the factory, faulty, or given out with a
 * note; fitting from it now, not later; batteries only for now.
 *
 * It is the service desk's — Arun's, and the office's (`service:desk`).
 *
 * Chargers too (owner, 26 Oct 2026: "add charger option also to in the head
 * office store next he will in the charger by scanning"): a lot scanned in
 * with its model picked once, each by its serial. A slip at the scan is put
 * right from the item's page while it is still in the store — the rest of
 * that scan with it in one go (the same day, 17 batteries were scanned in
 * without their company).
 *
 * Nothing is scanned out by hand any more (owner, 26 Oct 2026: "there should
 * be no out system in the store battery will be only out of the store during
 * dispatch"): a battery or charger leaves on the dispatch that carries it, and
 * a battery can still be fitted on a head office vehicle from its page. The
 * statuses "sent to the factory", "faulty" and "given out" stay for what was
 * recorded that way before.
 */
import { DISPATCH_CHARGER_MODELS } from './dispatch-form.js';

export const HO_BATTERY_STATUSES = ['IN_STORE', 'ON_THE_WAY', 'FITTED', 'SENT_FACTORY', 'FAULTY', 'GIVEN_OUT'] as const;
export type HoBatteryStatus = (typeof HO_BATTERY_STATUSES)[number];
export const HO_BATTERY_STATUS_LABELS: Record<HoBatteryStatus, string> = {
  IN_STORE: 'In the store',
  ON_THE_WAY: 'On the way to the other store',
  FITTED: 'On a vehicle',
  SENT_FACTORY: 'Sent to the factory',
  FAULTY: 'Faulty',
  GIVEN_OUT: 'Given out',
};

export const HO_BATTERY_EVENT_LABELS: Record<string, string> = {
  RECEIVED: 'Scanned in',
  CAME_OFF: 'Came off a vehicle',
  FITTED: 'Fitted',
  SENT_FACTORY: 'Sent to the factory',
  FAULTY: 'Faulty',
  GIVEN_OUT: 'Given out',
  CORRECTED: 'Corrected',
  MOVED: 'Moved between stores',
};

/**
 * The two stores a battery or charger stands in, each by its serial (owner, 5 Nov 2026: "person will
 * scan the batteries and it will be trasnfered to factory store from head office store there are now
 * 2 ways battery moves here and there one in dispatch goes with the vehicle and one battery can be
 * moved from one store to another"). Scanned out of one is in the other at once.
 */
export const HO_STORES = ['HEAD_OFFICE', 'FACTORY'] as const;
export type HoStore = (typeof HO_STORES)[number];
export const HO_STORE_LABELS: Record<HoStore, string> = { HEAD_OFFICE: 'HEAD OFFICE store', FACTORY: 'Factory store' };
export const otherHoStore = (store: HoStore): HoStore => (store === 'FACTORY' ? 'HEAD_OFFICE' : 'FACTORY');

/** A move in words: a fitting made by a dispatch reads as that dispatch, and so does what came back from one. */
export function hoEventLabel(event: { kind: string; dispatchId?: string | null }): string {
  if (event.kind === 'FITTED' && event.dispatchId) return 'Out on dispatch';
  if (event.kind === 'CAME_OFF' && event.dispatchId) return 'Back from a dispatch';
  return HO_BATTERY_EVENT_LABELS[event.kind] ?? event.kind;
}

/** The store's two kinds of thing, each by its serial. */
export type HoPart = 'battery' | 'charger';

/** The charger models the dispatch form lists, less "WITHOUT CHARGER". */
export const HO_CHARGER_MODELS = DISPATCH_CHARGER_MODELS.filter((model) => model !== 'WITHOUT CHARGER');

/** At most this many serials in one scan-in. */
export const HO_LOT_MAX = 200;

/** The key a serial is matched on: as scanned, cleaned, upper-cased. */
export function hoSerialKey(serial: string): string {
  return serial.replace(/\p{Cc}+/gu, ' ').replace(/\s+/g, ' ').trim().toUpperCase();
}

export interface HoBatteryRow {
  id: string;
  serialNo: string;
  batteryAh: string | null;
  company: string | null;
  status: HoBatteryStatus;
  /** Where it stands while IN_STORE. */
  store: HoStore;
  chassisNo: string | null;
  /** The last thing that happened to it, in words, and when. */
  last: { kind: string; at: string; by: string; note: string | null; chassisNo: string | null; dispatchId?: string | null } | null;
}

export interface HoBatteryEventRow {
  id: string;
  kind: string;
  at: string;
  by: string;
  note: string | null;
  chassisNo: string | null;
  /** The dispatch it went out on, or came back from. */
  dispatchId?: string | null;
}

export interface HoChargerRow {
  id: string;
  serialNo: string;
  model: string | null;
  status: HoBatteryStatus;
  /** Where it stands while IN_STORE. */
  store: HoStore;
  chassisNo: string | null;
  last: { kind: string; at: string; by: string; note: string | null; chassisNo: string | null; dispatchId?: string | null } | null;
}

export interface HoChargerSummary {
  inStore: number;
  /** What stands in the store, by model. */
  byModel: Array<{ model: string | null; count: number }>;
}

/**
 * One item and every move it made. `sameLot` is how many others came in on the
 * same scan, are still in the store and still recorded as this one is — the
 * ones a correction can put right with it.
 */
export interface HoItemHistory<Row> {
  item: Row;
  events: HoBatteryEventRow[];
  sameLot: number;
}

export interface HoStoreSummary {
  inStore: number;
  /** What stands in the store, by size and company. */
  bySize: Array<{ batteryAh: string | null; company: string | null; count: number }>;
}

// ---------------------------------------------------------------------------
// Counted parts (owner, 27 Oct 2026: "add these parts as well in head office store they dont
// require scanning they will come to head office store from factory store someone from factory
// will transfer these to head office store and someone in head office store will accept it").
// They leave on the dispatch by a fixed list for the body ("on dispatch fix number of items will be
// removed different for passenger and cargo give a option to make a fixed list there only").
// ---------------------------------------------------------------------------

// L3 passenger and L3 cargo apart (owner, 29 Oct 2026: "i want tow more category in l3 cargo l3
// passenger in head office store dispatch list"); PASSENGER and CARGO are the L5's — the keys kept
// as they were saved.
export const HO_KIT_BODIES = ['PASSENGER', 'CARGO', 'L3_PASSENGER', 'L3_CARGO'] as const;

/**
 * Dispatches from this moment take the fixed list (27 Oct 2026, as the opening stock was counted):
 * a vehicle sent before it left before the count, so its parts were never on the counted shelf.
 */
export const HO_PARTS_FROM = '2026-10-27T19:30:00+05:30';
export type HoKitBody = (typeof HO_KIT_BODIES)[number];
export const HO_KIT_BODY_LABELS: Record<HoKitBody, string> = { PASSENGER: 'L5 passenger', CARGO: 'L5 cargo', L3_PASSENGER: 'L3 passenger', L3_CARGO: 'L3 cargo' };

/** An E-Max or a Pro is an L5; every other model an L3 (as `vehicleClassFor` reads them). */
export const hoIsL5Model = (model: string | null | undefined): boolean => /E[\s-]*MAX|\bPRO\b/i.test(model ?? '');

/**
 * The list a dispatched vehicle goes out on: passenger or cargo by the dispatch form's VARIENT when
 * it says (PASSENGER, or a loader, a jumbo, a dust cart — all cargo), else by the model's class;
 * L3 or L5 by the model.
 */
export function hoKitBodyFor(varient: string | null | undefined, cargoByModel: boolean, model?: string | null): HoKitBody {
  const said = (varient ?? '').trim();
  const cargo = said ? !/^passenger$/i.test(said) : cargoByModel;
  if (model !== undefined && !hoIsL5Model(model)) return cargo ? 'L3_CARGO' : 'L3_PASSENGER';
  return cargo ? 'CARGO' : 'PASSENGER';
}

export interface HoCountedPartRow {
  id: string;
  name: string;
  unit: string;
  quantity: number;
  /** Linked to the factory store's part it is sent as. */
  factoryItemName: string | null;
  kit: Record<HoKitBody, number>;
  last: { kind: string; delta: number; at: string; note: string | null; by: string | null } | null;
}

export interface HoPartTransferRow {
  id: string;
  serial: number;
  status: 'ON_THE_WAY' | 'DONE' | 'CANCELLED';
  /** The store that sent it; the other one accepts (5 Nov 2026). */
  from: HoStore;
  note: string | null;
  sentBy: string | null;
  sentAt: string;
  receivedBy: string | null;
  receivedAt: string | null;
  receiveNote: string | null;
  lines: Array<{
    id: string;
    /** A part by count, or one battery or charger by its serial (5 Nov 2026). */
    kind: 'PART' | 'BATTERY' | 'CHARGER';
    serialNo: string | null;
    factoryItemId: string | null;
    name: string;
    unit: string;
    sent: number;
    received: number | null;
    /** The HEAD OFFICE part it goes into, when that is known already. */
    partId: string | null;
    partName: string | null;
  }>;
}

export interface HoCountedPartsResponse {
  parts: HoCountedPartRow[];
  /** From the factory, waiting to be accepted here. */
  coming: HoPartTransferRow[];
}

export const hoPartEntryLabel = (kind: string): string =>
  ({ OPENING: 'Opening stock', RECEIVED: 'From the factory', SENT: 'To the factory', DISPATCH: 'Out on a dispatch', ADJUST: 'Count put right' })[kind] ?? kind;
